import { DetailsList, Text, ICommandBarItemProps, IDialogContentProps, Selection, DetailsListLayoutMode, SelectionMode, CheckboxVisibility, IColumn, IDetailsListStyles, DetailsHeader, CommandBar, MessageBar, mergeStyleSets, ICommandBarStyles, IButtonProps, MessageBarType, DialogType, Dialog, DialogFooter, PrimaryButton, DefaultButton, Icon, ContextualMenu, IContextualMenuItem, ContextualMenuItemType, TooltipHost } from '@fluentui/react';
import React from 'react'
import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { checkRoles } from '../../../hoc/CheckRoles';
import { RoleContext } from '../../../shared/enums';
import { IMailbox } from '../../../shared/interfaces';
import { RootState } from '../../../store';
import CircleLoader from '../../Loader/CircleLoader/CircleLoader';
import abilityBuild from '../../../shared/CASL/appAbility';
import { subject, Unsubscribe } from "@casl/ability";
import CustomCommandBarMenuItem from '../../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';
import mailboxesService from '../../../services/mailboxes.service';
import { toastRef } from '../../Layout/Layout';
import AddEditMailboxesManager from './AddEditMailboxesManager';

const classNames = mergeStyleSets({
    overFlowHidden: {
        overflow: 'hidden'
    },
    detailsListRow: {
        '.ms-DetailsRow-check': {
            height: '100%',
            width: 36
        },
        '.ms-DetailsRow-fields .ms-DetailsRow-cell': {
            paddingLeft: 0
        }
    }
});

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee' },
};

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};

const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUser: state.sessionReducer.currentUser,
    features: state.sessionReducer.features,
    allRoles: state.sessionReducer.allRoles,
    isMobile: state.sessionReducer.isMobile,
})

const mapDispatch = {

}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface MailboxesManagerProps {

}

type Props = MailboxesManagerProps & RouteComponentProps & PropsFromRedux;

export interface MailboxesManagerState {
    commandBarItems: ICommandBarItemProps[]
    items: IMailbox[]
    columns: IColumn[]
    selectedMailbox?: IMailbox
    lateralPanelIsOpen: boolean
    lateralPanelBodyContent: Function
    lateralPanelSubmitFunction: Function
    confirmDialogIsOpen: boolean
    confirmDialogContentProps: IDialogContentProps
    confirmDialogSubmitFunction: Function
    loadingMailboxesList: boolean
    forceMailboxManagerTableRefresh: boolean
    showMessageBar: boolean,
    userMessageError: string,
    showContextualMenu: boolean
    contextMenuItems: IContextualMenuItem[] | undefined
    contextMenuPosition: any
}
class MailboxesManager extends React.Component<Props, MailboxesManagerState> {
    cancelTokenSources = {};
    unsubscribeFromAbility: Unsubscribe = () => { };
    private mailboxSelection: Selection | undefined;

    constructor(props) {
        super(props);

        this.mailboxSelection = new Selection({
            onSelectionChanged: () => {
                const selection = this.mailboxSelection!.getSelection()[0] as IMailbox;
                this.setState({ selectedMailbox: selection })
            }
        })

        this.state = {
            commandBarItems: [],
            items: [],
            columns: [
                {
                    key: 'address',
                    fieldName: 'address',
                    name: 'Indirizzo di posta',
                    minWidth: 100,
                    maxWidth: 200,
                    isResizable: true,
                    onRender: (item) => {
                        return <TooltipHost content={item.address} id={`tooltip_${item.address}`}>
                            {item.address}
                        </TooltipHost>
                    }
                },
                {
                    key: 'enabled',
                    fieldName: 'enabled',
                    name: 'Cassetta di posta attiva',
                    minWidth: 100,
                    maxWidth: 200,
                    isResizable: true,
                    onRender: (item) => {
                        if (item.enabled) {
                            return <span><Icon iconName={"CheckMark"} style={{ color: 'green', fontSize: '15px', fontWeight: 'bold' }} /></span>
                        }
                    }
                },
                /// Aggiungo una colonna vuota in coda alla tabella, è necessaria per consentire l'allineamneto tra
                /// l'header e i contenuti della tabella 
                {
                    key: 'empty',
                    name: 'empty',
                    fieldName: 'empty',
                    isIconOnly: true,
                    minWidth: 1,
                    maxWidth: 1,
                    onRender: (item) => {

                    },
                },
            ],
            lateralPanelIsOpen: false,
            lateralPanelBodyContent: () => { },
            lateralPanelSubmitFunction: () => { },
            confirmDialogIsOpen: false,
            confirmDialogContentProps: {},
            confirmDialogSubmitFunction: () => { },
            loadingMailboxesList: false,
            forceMailboxManagerTableRefresh: false,
            showMessageBar: false,
            userMessageError: "",
            showContextualMenu: false,
            contextMenuItems: [],
            contextMenuPosition: undefined
        }

    }

    componentDidMount() {
        this.unsubscribeFromAbility = abilityBuild.on('updated', () => {
            if (abilityBuild.cannot('use', subject('IFeature', { key: 'PecMail', enabled: true }))) {
                this.props.history.push({ pathname: '/notfound' });
            }
            else if (abilityBuild.cannot('create', 'IMailbox')) {
                this.props.history.push({ pathname: '/unauthorized' });
            }
            this.updateCommandBarItems();
        });

        if (this.props.currentAoo) {
            this.updateCommandBarItems();
        }
        this.getMailboxes();

    }

    componentDidUpdate(oldProps: Props, oldState: MailboxesManagerState) {

        if (oldProps.currentAoo !== this.props.currentAoo
            || oldState.selectedMailbox !== this.state.selectedMailbox) {
            this.updateCommandBarItems();
        }

        if (oldProps.currentAoo !== this.props.currentAoo) {
            this.getMailboxes();
        }

        if (oldState.forceMailboxManagerTableRefresh !== this.state.forceMailboxManagerTableRefresh) {
            this.setState({
                items: []
            });
            this.mailboxSelection?.setItems([]);
            this.getMailboxes();
        }
    }

    componentWillUnmount() {
        this.unsubscribeFromAbility();
    }

    getMailboxes() {
        if (this.props.currentAoo) {
            this.setState({ loadingMailboxesList: true });
            mailboxesService.getMailboxes(this.props.currentAoo?.id!)
                .then(mailboxes => {
                    this.setState({ items: mailboxes, loadingMailboxesList: false })
                });
        }
    }

    updateCommandBarItems = () => {

        let newCommandBarItems: ICommandBarItemProps[] = [];
        if (abilityBuild.can('create', 'IMailbox'))
            newCommandBarItems.push(
                {
                    key: 'addMailbox',
                    iconProps: { iconName: 'Add' },
                    text: 'Aggiungi',
                    onClick: this.addMailboxManagerHandler
                });

        if (abilityBuild.can('update', 'IMailbox') && this.state.selectedMailbox)
            newCommandBarItems.push({
                key: 'editMailbox',
                iconProps: { iconName: 'EditMail' },
                text: 'Modifica',
                onClick: this.editMailboxManagerHandler
            });

        if (abilityBuild.can('delete', 'IMailbox') && this.state.selectedMailbox)
            newCommandBarItems.push({
                key: 'deleteMailbox',
                iconProps: { iconName: 'Delete' },
                text: 'Elimina',
                onClick: this.deleteMailboxManagerHandler
            });

        this.setState({ commandBarItems: newCommandBarItems });
    }


    onRenderDetailsHeader = (detailsHeaderProps) => {
        const detailsListHeadrerStyles: Partial<IDetailsListStyles> = {

            root: { boxSizing: 'content-box !important' }

        };
        return (
            <DetailsHeader
                {...detailsHeaderProps}
                styles={detailsListHeadrerStyles}
            />
        );
    }

    // Click sul button della commandbar - Aggiungi cassetta
    addMailboxManagerHandler = () => {

        this.setState(
            {
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddEditMailboxesManager
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Nuovo indirizzo'
                    loading={false}
                    onSubmit={this.addMailboxLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}
                    panelIsEdit={false}
                    mailboxesList={this.state.items}
                />
            }
        );
        this.mailboxSelection!.setAllSelected(false);
    }

    // Click su salva del panel laterale - Aggiungi mailbox
    addMailboxLateralPanelSubmit = (mailbox: Partial<IMailbox>) => {
        this.setState({
            lateralPanelIsOpen: false,
            confirmDialogIsOpen: true,
            confirmDialogContentProps: {
                type: DialogType.normal,
                title: 'Conferma',
                closeButtonAriaLabel: 'Close',
                subText: 'Vuoi aggiungere un nuovo indirizzo?',
            },
            confirmDialogSubmitFunction: () => { this.addMailboxConfirmDialogSubmit(mailbox) }
        })
    }

    //// Click su conferma del confirm dialog - Aggiungi mailbox
    addMailboxConfirmDialogSubmit = (mailbox: Partial<IMailbox>) => {
        if (this.props.currentAoo) {
            this.setState({ loadingMailboxesList: true });
            let { forceMailboxManagerTableRefresh } = this.state;

            mailboxesService.addMailbox(this.props.currentAoo.id, mailbox)
                .then(result => {
                    this.setState({ forceMailboxManagerTableRefresh: !forceMailboxManagerTableRefresh });
                    toastRef.current?.show({
                        severity: 'info',
                        summary: mailbox.address,
                        detail: `Indirizzo aggiunto correttamente`,
                        life: 5000
                    });
                })
                .catch(error => {
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: mailbox.address,
                            detail: `Non è stato possibile aggiungere l'indirizzo`,
                            life: 5000
                        });
                    }
                })

            this.setState({ confirmDialogIsOpen: false, loadingMailboxesList: false })
        }
    }

    //// Click sul button della commandbar - Modifica mailbox
    editMailboxManagerHandler = () => {
        this.setState(
            {
                lateralPanelIsOpen: true,
                lateralPanelBodyContent: () => <AddEditMailboxesManager
                    panelIsOpen={this.state.lateralPanelIsOpen}
                    panelHeaderText='Modifica indirizzo'
                    loading={false}
                    selectedMailboxManager={this.state.selectedMailbox}
                    onSubmit={this.editMailboxLateralPanelSubmit}
                    onDismiss={this.dismissLateralPanel}
                    panelIsEdit={true}
                    mailboxesList={this.state.items}
                />
            }
        );
    }

    //// Click su salva del panel laterale - Modifica mailbox
    editMailboxLateralPanelSubmit = (mailbox: Partial<IMailbox>) => {
        let { selectedMailbox } = this.state;
        if (selectedMailbox) {
            this.setState({
                lateralPanelIsOpen: false,
                confirmDialogIsOpen: true,
                confirmDialogContentProps: {
                    type: DialogType.normal,
                    title: 'Conferma',
                    closeButtonAriaLabel: 'Close',
                    subText: `Vuoi modificare l'indirizzo ${selectedMailbox.address}?`,
                },
                confirmDialogSubmitFunction: () => { this.editMailboxConfirmDialogSubmit(mailbox) }
            })
        }
    }

    //// Click su conferma del confirm dialog - Modifica mailbox
    editMailboxConfirmDialogSubmit = (mailbox: Partial<IMailbox>) => {
        if (this.props.currentAoo) {
            this.setState({ loadingMailboxesList: true });
            let { forceMailboxManagerTableRefresh } = this.state;

            mailboxesService.updateMailbox(this.props.currentAoo.id, mailbox!.id!, mailbox)
                .then(result => {
                    this.setState({ forceMailboxManagerTableRefresh: !forceMailboxManagerTableRefresh });
                    toastRef.current?.show({
                        severity: 'info',
                        summary: mailbox.address,
                        detail: `Indirizzo aggiornato correttamente`,
                        life: 5000
                    });
                })
                .catch(error => {
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: mailbox.address,
                            detail: `Non è stato possibile aggiornare l'indirizzo`,
                            life: 5000
                        });
                    }
                });

            this.setState({ confirmDialogIsOpen: false, loadingMailboxesList: false });
            this.mailboxSelection!.setAllSelected(false);
        }
    }

    //// Click sul button della commandbar - Elimina mailbox
    deleteMailboxManagerHandler = () => {
        let { selectedMailbox } = this.state;
        if (selectedMailbox) {
            this.setState(
                {
                    lateralPanelIsOpen: false,
                    confirmDialogIsOpen: true,
                    confirmDialogContentProps: {
                        type: DialogType.normal,
                        title: 'Conferma',
                        closeButtonAriaLabel: 'Close',
                        subText: `Vuoi rimuovere l'indirizzo ${selectedMailbox.address}?`,
                    },
                    confirmDialogSubmitFunction: () => { this.deleteUserManagerConfirmDialogSubmit() }
                }
            );
        }
    }

    //// Click su conferma del confirm dialog - Elimina mailbox
    deleteUserManagerConfirmDialogSubmit = () => {
        if (this.props.currentAoo && this.state.selectedMailbox) {
            let { forceMailboxManagerTableRefresh } = this.state;

            let selectedMailbox: IMailbox = { ...this.state.selectedMailbox };

            mailboxesService.deleteMailbox(this.props.currentAoo.id, selectedMailbox.id)
                .then(result => {
                    this.setState({ forceMailboxManagerTableRefresh: !forceMailboxManagerTableRefresh });
                    toastRef.current?.show({
                        severity: 'info',
                        summary: selectedMailbox.address,
                        detail: `Indirizzo rimosso correttamente`,
                        life: 5000
                    });
                })
                .catch(error => {
                    if (!error.isErrorShown) {
                        toastRef.current?.show({
                            severity: 'error',
                            summary: 'Attenzione',
                            detail: `Non è stato possibile rimuovere l'indirizzo`,
                            life: 5000
                        });
                    }

                });

            this.setState({ confirmDialogIsOpen: false })
            this.mailboxSelection!.setAllSelected(false);
        }
    }

    dismissLateralPanel = (ev?: React.SyntheticEvent<HTMLElement, Event> | KeyboardEvent | undefined) => {
        ev?.preventDefault();
        ev?.stopPropagation();
        this.setState({ lateralPanelIsOpen: false })
    }

    dismissConfirmDialog = () => {
        this.setState({ confirmDialogIsOpen: false })
    }

    // metodi gestione context menu 
    onShowContextualMenu = (item, index, ev) => {
        ev.preventDefault();

        const menuItems = this.updateContextMenuMailboxesManager();
        this.setState({ contextMenuItems: menuItems, showContextualMenu: true, contextMenuPosition: ev });
    };

    updateContextMenuMailboxesManager = () => {
        const menuItems: IContextualMenuItem[] = [];

        if (abilityBuild.can('update', 'IMailbox')) {
            menuItems.push(
                {
                    key: 'edit',
                    text: 'Modifica',
                    iconProps: { iconName: 'EditMail' },
                    onClick: () => {
                        this.editMailboxManagerHandler();
                        this.onHideContextualMenu();
                    }
                }
            );
        }
        if (abilityBuild.can('delete', 'IMailbox')) {
            menuItems.push(
                {
                    key: 'delete',
                    text: 'Elimina',
                    iconProps: { iconName: 'Delete' },
                    onClick: () => {
                        this.deleteMailboxManagerHandler();
                        this.onHideContextualMenu();
                    }
                }
            );
        }
        return menuItems;
    };

    onHideContextualMenu = () => {
        this.setState({ contextMenuItems: undefined, showContextualMenu: false });
    };

    render() {

        return (
            <React.Fragment>
                {this.state.lateralPanelBodyContent()}

                <Dialog
                    hidden={!this.state.confirmDialogIsOpen}
                    onDismiss={this.dismissConfirmDialog}
                    dialogContentProps={this.state.confirmDialogContentProps}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={() => this.state.confirmDialogSubmitFunction()} text="Conferma" />
                        <DefaultButton onClick={this.dismissConfirmDialog} text="Annulla" />
                    </DialogFooter>
                </Dialog>

                <div className="users-manager-component" >

                    {this.state.commandBarItems.length > 0 &&
                        <CommandBar
                            overflowButtonProps={overflowProps}
                            items={this.state.commandBarItems}
                            styles={commandBarStyles}
                        />
                    }
                    {this.state.showMessageBar &&
                        <MessageBar
                            messageBarType={MessageBarType.blocked}
                            isMultiline={true}
                            onDismiss={() => this.setState({ showMessageBar: false })}
                            dismissButtonAriaLabel="Close">
                            {this.state.userMessageError}
                        </MessageBar>
                    }


                    <CircleLoader loaderClass='loader-large' loading={this.state.loadingMailboxesList} />

                    {
                        this.state.items && this.state.items.length > 0
                            ? <DetailsList
                                className="with-empty-column"
                                items={this.state.items}
                                columns={this.state.columns}
                                layoutMode={DetailsListLayoutMode.justified}
                                onRenderDetailsHeader={this.onRenderDetailsHeader}
                                selection={this.mailboxSelection}
                                selectionPreservedOnEmptyClick={true}
                                selectionMode={SelectionMode.single}
                                checkboxVisibility={CheckboxVisibility.onHover}
                                onItemContextMenu={this.onShowContextualMenu}
                            />
                            : <div style={{ marginLeft: '31px' }}>
                                <Text> Nessuna e-mail da visualizzare</Text>
                            </div>
                    }
                    <ContextualMenu
                        items={this.state.contextMenuItems!}
                        hidden={!this.state.showContextualMenu}
                        target={this.state.contextMenuPosition}
                        onItemClick={this.onHideContextualMenu}
                        onDismiss={this.onHideContextualMenu}
                    />


                </div>

            </React.Fragment >
        )
    }
}

export default connector(checkRoles(MailboxesManager, RoleContext.Aoo));